/*
 * Use this file for globals
 * This file is a good place to read variables from config and export them
 * We do not want to read directly from config in many modules, because the way
 * config is handled can change in the future. If config handling changes, we only need
 * to change this file.
 */

const config = require('./config').default;
import { tokens } from 'src/design-system';

/*
 * Read from config, and set appropriate defaults
 * Config may not have all variable set, but globals will set all required variables
 * so that importing modules have no surprises
 */
export const BASE_URL = config.BASE_URL;
export const USE_HARDCODED_MASTER_DATA = config.USE_HARDCODED_MASTER_DATA;
export const HARDCODED_MASTER_DATA = config.HARDCODED_MASTER_DATA;
export const SOCKET_SERVER_URL = config.SOCKET_SERVER_URL;
export const API_BASE_URL = config.API_BASE_URL;
export const INVOICE_API_BASE_URL = config.INVOICE_API_BASE_URL;
export const DEFAULT_ORG_PRETTY_NAME = config.DEFAULT_ORG_PRETTY_NAME;
export const SESSION_STACK_KEY = config.SESSION_STACK_KEY;
export const LOG_ROCKET_KEY = config.LOG_ROCKET_KEY;
export const SENTRY_KEY = config.SENTRY_KEY;
export const ENVIRONMENT = config.ENVIRONMENT;
export const SIDEMENU_CONFIG = config.SIDEMENU_CONFIG;
export const HUBSPOT_EXTERNAL_API_URL = config.HUBSPOT_EXTERNAL_API_URL;
export const HUBSPOT_PORTAL_ID = config.HUBSPOT_PORTAL_ID;
export const HUBSPOT_FINANCING_SHIPPER_FORM_GUID = config.HUBSPOT_FINANCING_SHIPPER_FORM_GUID;
export const HUBSPOT_FINANCING_SERVICE_PROVIDER_FORM_GUID = config.HUBSPOT_FINANCING_SERVICE_PROVIDER_FORM_GUID;
export const HUBSPOT_AUTH_TOKEN = config.HUBSPOT_AUTH_TOKEN;

// Static globals — values now sourced from design tokens.
// These exports are kept for backward compatibility during migration.
// New code should use theme.* tokens directly.
export const NAVBAR_HEIGHT = 60;
/** @deprecated Use theme.zIndex.navbar from design-system instead */
export const NAVBAR_ZINDEX = tokens.zIndex.navbar;
/** @deprecated Use theme.breakpoint.sm from design-system instead */
export const MOBILE_BREAK_POINT = tokens.breakpoint.sm;
/** @deprecated Use theme.breakpoint.xl from design-system instead */
export const MIN_WIDTH = tokens.breakpoint.xl;
// LTL globals
export const LTL_POLLING_FREQUENCY = config.LTL_POLLING_FREQUENCY || 30000;
export const DOMESTIC_STATUS_FETCH_POLLING_FREQUENCY =
  config.DOMESTIC_STATUS_FETCH_POLLING_FREQUENCY || 10000;
export const GOOGLE_ANALYTICS_MEASUREMENT_ID = config.GOOGLE_ANALYTICS_MEASUREMENT_ID;
export const RFQ_ANALYTICS_DATA = config.RFQ_ANALYTICS_DATA || [];
export const CT_POLLING_FREQUENCY = config.CT_POLLING_FREQUENCY || 30000;
export const CUSTOM_FRONTEND_BASEURLS = config.CUSTOM_FRONTEND_BASEURLS || undefined;
export const CT_API_SWAGGER_SPEC_URL = config.CT_API_SWAGGER_SPEC_URL || undefined;
export const DEMO_ORGANISATIONS = config.DEMO_ORGANISATIONS || [];
export const PLATFORM_BASENAME = '/s';
export const GOOGLE_PLACES_API_URL = config.GOOGLE_PLACES_API_URL;
export const IFRAME_NON_STRICT_MODE = config.IFRAME_NON_STRICT_MODE || false;
export const ANALYTICS_BASE_PATH = '/analytics';
export const GENERIC_ANALYTICS_URL = config.GENERIC_ANALYTICS_URL;
// export const ANALYTICS_BACKEND_URL = config.ANALYTICS_BACKEND_URL;
export const CHARGEBEE_PUBLISHABLE_KEY = config.CHARGEBEE_PUBLISHABLE_KEY;
export const SITE_NAME = config.SITE_NAME;
export const DEVREV_TOKEN_URL = config.DEVREV_TOKEN_URL;
export const DEVREV_APP_ID = config.DEVREV_APP_ID;
